import router from '../router'
import { apolloClient, AUTH_TOKEN, onLogin, onLogout } from '../vue-apollo'

const state = {
  isLoggedIn: !!localStorage.getItem(AUTH_TOKEN),
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
}

const actions = {
  async login({ commit }, token) {
    await onLogin(apolloClient, token)
    router.push(router.history.current.query.redirect || '/')
    commit('login')
  },

  async logout({ commit }) {
    await onLogout(apolloClient)
    router.push('/login')
    commit('logout')
  },
}

const mutations = {
  login(state, payload) {
    state.isLoggedIn = true
  },
  logout(state, payload) {
    state.isLoggedIn = false
  },
}

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
